import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";


export const useProductCart = create()(
  persist(
    (set) => ({
      product: {},
      setProduct: (item) => {
        set(() => {
          return { product: item };
        });
      },
    }),
    {
      name: "product-cart", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // 'localStorage','sessionStorage' is used 
    }
  )
);